import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const NorfolkIsland: Country = {
    identifier: "NorfolkIsland",
    name: "Norfolk Island",
    countryCode: "NF",
    group: CountryGroup.OCEANIA,
    isUNMember: false,
    flag: "🇳🇫",
    svgPath: "m 946.21575,547.5604 0.056,0.033 0.052,0.019 0.034,0.025 -0.005,0.054 -0.026,0.054 -0.032,0.023 -0.01,0.007 -0.007,0.011 -0.003,0.011 0,0.014 -0.016,-0.045 -0.03,-0.03 -0.029,-0.003 -0.021,0.035 -0.017,0 -0.006,-0.036 -0.012,-0.031 -0.005,-0.03 0.012,-0.024 0.022,-0.029 0.001,-0.024 -0.017,-0.011 -0.035,0.01 0.041,-0.046 z",
}
